import { GridSortModel } from "@mui/x-data-grid";

export type ObjectId = string;

export enum Status {
  PENDING = "PENDING",
  DONE = "DONE",
  ERROR = "ERROR",
  ABORTED = "ABORTED",
  IN_PROGRESS = "IN_PROGRESS",
  FINALIZE = "FINALIZE",
}

export interface PostRequest {
  workspace_id: string | null;
}

export type ExportFormat = "csv" | "json" | "xlsx" | "csv_for_excel";

export interface PaginationParams {
  page?: number;
  limit?: number;
  sortFields?: GridSortModel;
}

export type PaginatedData<T> = {
  page: number;
  limit: number;
  total_count: number;
  total_pages: number;
  items: T[];
};
